import { PersistenceId } from "../../../_config/PersistenceId";

export class FournisseurId extends PersistenceId {
    get PREFIX_ID() {
        return "F"
    }
}

